import { createAction, props } from '@ngrx/store';

export const increaseLoadingCount = createAction('[Loading] Increase Count');

export const decreaseLoadingCount = createAction('[Loading] Decrease Count');
